module.exports = __webpack_public_path__ + "img/1.14d37ccb.png";